import { Alert, Button, Card, CardContent, FormControl, TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { registerWithEmailAndPasswordAsync, resetFault, resetSendResetPasswordEmail, selectAuthFault, selectIsAuth, selectSendResetPasswordEmail, sendPasswordResetEmailAsync, signInWithEmailAndPasswordAsync } from './AuthSlice';
import { useLocation, useNavigate, useParams } from 'react-router';
import { ProtectedRedirectState } from './Login';
import { authFultMsgById } from '../../app/const';

const LoginWithEmail = () => {
  const { loginType } = useParams() // 'login' or 'register'
  const dispatch = useAppDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const authFault = useAppSelector(selectAuthFault)
  const isAuth = useAppSelector(selectIsAuth)
  const sendResetPasswordEmail = useAppSelector(selectSendResetPasswordEmail)
  const redirectTo = (location && location.state) ? (location.state as ProtectedRedirectState).from.pathname : '/home'
  useEffect(() => { dispatch(resetFault()) }, [])
  useEffect(() => {
    if (isAuth) {
      navigate({ 'pathname': redirectTo, 'search': (location.state as any)?.from?.search, })
    }
    return () => {
      dispatch(resetSendResetPasswordEmail())
    }
  }, [isAuth, redirectTo, navigate, location.state])
  return <Box sx={{
    width: '100%',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    flexDirection: 'column'
  }} mt={2}>
    <Card sx={{ width: 500 }}>
      <CardContent>
        {authFault?.code && <Alert severity="error">{authFultMsgById(authFault.code)}</Alert>}
        <Box sx={{ width: '100%', textAlign: 'center' }}>
          {loginType === 'register' ? <Typography variant="h5" gutterBottom>Register with your email</Typography> : <Typography variant="h5" gutterBottom>Login with your email</Typography>}
          {sendResetPasswordEmail && <Alert severity="info">Password reset email sent to {email}. Please check your inbox for instructions.</Alert>}
          <FormControl sx={{ width: '100%', textAlign: 'center' }}>
            <FormControl sx={{ m: 1 }} variant="outlined">
              <TextField id="register-email" label="Email" variant="outlined" defaultValue={email}
                onChange={(event) => setEmail(event.target.value)} />
            </FormControl>
            <FormControl sx={{ m: 1 }} variant="outlined">
              <TextField id="register-password" label="Password" variant="outlined" defaultValue={password} type="password"
                onChange={(event) => setPassword(event.target.value)} />
            </FormControl>
            {loginType === 'register' ? <Button disabled={!email || !password} variant="contained" sx={{ marginBottom: 5, width: '300px', alignSelf: 'center' }} onClick={() => {
              dispatch(registerWithEmailAndPasswordAsync({ redirectTo, email, password }))
            }}>Register</Button>
              : <><Button disabled={!email || !password} variant="contained" sx={{ marginBottom: 5, width: '300px', alignSelf: 'center' }} onClick={() => {
                dispatch(signInWithEmailAndPasswordAsync({ redirectTo, email, password }))
              }}>Login</Button>
                <Button disabled={!email || sendResetPasswordEmail} variant="outlined" size="small" sx={{ marginBottom: 5, width: '300px', alignSelf: 'center' }} onClick={() => {
                  dispatch(sendPasswordResetEmailAsync(email))
                }}>Forgot password</Button>
              </>}
          </FormControl>
          <Typography variant="caption" color="text.secondary" sx={{ marginBottom: 5, alignSelf: 'center' }}>Back to login with <i>Microsoft</i> or <i>Google</i> with few clicks.</Typography>
          <Button variant="outlined" size="small" sx={{ marginBottom: 5, width: '300px', alignSelf: 'center' }} onClick={() => {
            dispatch(resetFault())
            navigate('/login')
          }}>Back</Button>
        </Box>
      </CardContent>
    </Card>
  </Box>
}

export default LoginWithEmail